var map = {
	"./en": [
		44
	],
	"./en.js": [
		44
	],
	"./en_US": [
		33
	],
	"./en_US.js": [
		33
	],
	"./es": [
		125,
		1
	],
	"./es.js": [
		125,
		1
	],
	"./pt_BR": [
		126,
		0
	],
	"./pt_BR.js": [
		126,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 32;


//////////////////
// WEBPACK FOOTER
// ./~/report-components/src/components/date.i18n lazy ^\.\/.*$
// module id = 32
// module chunks = 4